import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components/index";
import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Locations',
	url: '/locations',
	icon: 'building',
}];

export default class Locations extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button onClick={this.toggle('modalLocation')} size="sm" color="primary">
						<i className="fa fa-building"/>&nbsp;&nbsp;Add Location
					</Button>
				</Framework.Components.PageBar>

				<Collections.Locations
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					showCSV={roles.includes(UserRoles.Admin)}
				/>
				/>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Location"}
					object={Objects.LocationDetail}
					history={this.props.history}
					toggle={this.state.modalLocation}
					reportClose={this.reportClose('modalLocation')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					size={"xl"}
				/>

			</div>
		);
	}
}

